import { Pipe, PipeTransform } from '@angular/core';
import { DsLibCheckRightsInterface } from '../interfaces/ds-lib-check-rights.interface';

@Pipe({
  name: 'dsLibCheckRights',
})
export class DsLibCheckRightsPipe implements PipeTransform {
  /**
   * Returns TRUE if item can be accessed.
   *
   * @param items Item needs right(s) to be accessed
   * @param rights List of user rights
   * @returns DsLibCheckRightsInterface[]
   */
  public transform(items: DsLibCheckRightsInterface[], rights: number[]): DsLibCheckRightsInterface[] {
    if (!items) {
      return items;
    }
    return items.filter((item) => {
      // If no special rights are needed, return true
      if (!item.rights || (item.rights && item.rights.length === 0)) {
        return true;
      }
      return item.rights.every((right) => rights.includes(right));
    });
  }
}
